import {Component, OnInit} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {CostBenchmarkData} from '../../../../models/cost-benchmark-data.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {DownloadDataService} from '../../../../../core/services/download-data.service';
import {Countries} from '../../../../../admin/models/countries.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-operations-vs-overhead-chart',
  templateUrl: './operations-vs-overhead-chart.component.html',
  styleUrls: ['./operations-vs-overhead-chart.component.scss']
})
export class OperationsVsOverheadChartComponent implements OnInit {

  text = 'Operations vs Overhead';
  subtitle!: string;
  order!: string | undefined;
  data!: CostBenchmarkData;
  displayUnits = '';
  years!: number[];
  countries!: Countries[];
  collectionStreams!: Master[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly downloadDataService: DownloadDataService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.kfChartsService.getCollectionStreams().subscribe(data => this.collectionStreams = data);
    this.downloadDataService.getAllCountries().subscribe(data => this.countries = data);
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('cost', 'WEEE_SYSTEM_SCHEMA')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          this.kfChartsService.getCostOperationalVsOverhead(search)
            .subscribe(response => {
              if (response.countries?.length > 3) {
                this.subtitle = search.startYear + ' (average)';
              } else {
                this.subtitle = 'To keep confidentiality, only charts with more than 3 data sets can be displayed, apologies for the inconvenience';
              }
              this.data = response;
            });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {

    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
    if (event.displayUnits != undefined) {
      this.displayUnits = event.displayUnits;
    }
    this.order = event.order;
  }

}
